<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BOyCCr/tc-custom/9780062192523.jpg?1725275569599" alt="This image is the cover for the book House of Secrets: Battle of the Beasts, House of Secrets Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">House of Secrets: Battle of the Beasts, House of Secrets Series
      </h1>
      <p class="bookDescription body article font2">
        <p>The sequel to the <i>New York Times</i> bestselling <i>House of Secrets</i>—hailed by J. K. Rowling as "a breakneck, jam-packed roller coaster of an adventure"—this second installment by Hollywood director Chris Columbus (of Harry Potter fame) and bestselling author Ned Vizzini (<i>It's Kind of a Funny Story</i>) is full of even more explosive twists and turns.</p><p>Since the siblings' last adventure, life in the Walker household is much improved—the family is rich and the Wind Witch is banished. But no Walker will be safe until she is found. Summoning her to San Francisco brings all the danger that comes with her, and puts the Walkers in the crosshairs of a mysterious journey through Denver Kristoff's books. As the Walkers travel from ancient Rome to World War II to Tibet, they are tested in ways that cut deeper than before—by Denver Kristoff, the Wind Witch, and one another.</p><p>Fantasy fiction fans who enjoy Rick Riordan will find much to love in this thrilling and action-packed novel.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Columbus, Ned Vizzini
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?061e7d31